import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_rh, cambios_no_guardados } from '../../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../../Services/AuthService';

import ModalService from '../../../../ModalService/ModalService';
import AlertForm from '../../../../../../../Services/AlertForm';
import FormularioRelacionados from './FormularioRelacionados';

const ModalEditRelacionados = ({ openEdit, setOpenEdit, elementSelect, editar, errorTable, informacionAdicional, idModulo }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenEdit( false );
        setError( null );
    }

    const actualizarRelacionado = ( relacionado ) => {
        axios.put( `${servicios_grupogack_rh}/movimientos/relacionado/`, relacionado, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        editar( respuesta.data.dataResponse[0] );
                        setOpenEdit( false );
                        break;
                    case 400:
                        setError( <AlertForm message={ respuesta.data.msg } /> );
                        break;
                    default:
                        errorTable( cambios_no_guardados );
                        break;
                }
            })
            .catch( error => {
                errorTable( cambios_no_guardados );
            })
    }

    return (
        <ModalService title="Actualizar Movimiento Relacionado" parentNode={idModulo } minWidth="40%"
            isOpen={ openEdit } onClose={ () => cerrarModal() } >
                <FormularioRelacionados
                    error={error}
                    elementSelect={elementSelect}
                    informacion={informacionAdicional}
                    actualizarRelacionado={actualizarRelacionado}
                />
        </ModalService>
    );
};

export default ModalEditRelacionados;